import { render } from "./NavbarMiddle.vue?vue&type=template&id=987c5104&scoped=true"
import script from "./NavbarMiddle.vue?vue&type=script&lang=js"
export * from "./NavbarMiddle.vue?vue&type=script&lang=js"

import "./NavbarMiddle.vue?vue&type=style&index=0&id=987c5104&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987c5104"]])

export default __exports__